import { Box, Collapse, IconButton, Table, TableCell, TableRow, TableHead, TableBody } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import { BsFileText } from "react-icons/bs";
import { usePedidos } from "../../../../contexts/Pedidos";
import ReactLoading from 'react-loading';
import { useModals } from "../../../../contexts/Modals";
import { TextOnlyTooltip } from "../../../../themes/components/TextOnlyTooltip";

interface HistPedido {
    evento: [
        {
            dateve: string,
            deseve: string,
            esteve: string,
            horeve: string
        }]
}

interface arrayHistPedidos {
    length: number;
    [index: number]: HistPedido
}

export function RowListaClientes(props: {
    row: ReturnType<any>,
    handleModal: (codcli: string) => void,
    history: ReturnType<any>,
    index: number
}) {
    const { row, handleModal, history } = props;
    const { mostrarInfoOK } = useModals();
    const { buscarHistoricoPed } = usePedidos();
    const [open, setOpen] = useState(false);
    const [localHistorico, setLocalHistorico] = useState<arrayHistPedidos>([]);
    const [localLoading, setLocalLoading] = useState(true);

    useEffect(() => {
        async function teste() {
            let hist = await buscarHistoricoPed(row.numPed, row.codemp, history)
            setLocalHistorico(hist);
            setLocalLoading(false);
        }
        if (open === true) {
            setLocalLoading(true);
            teste();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);


    return (
        <React.Fragment>
            <TableRow className={`linha_${props.index % 2 === 0 ? "par" : "impar"}`}>
                <TableCell scope="row" style={{ border: 'none' }} >{row.codcli}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.nomcli}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.cgccpf}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.cidcli + "/" + row.sigufs}</TableCell>
                <TableCell align="left" style={{ border: 'none' }} >{row.sitcli.toLowerCase() === "a" ? "Ativo" : "Inativo"}</TableCell>
                <TableCell align="right" width="50px" style={{ border: 'none' }} >
                    <TextOnlyTooltip title="Detalhes" placement="top">
                        <button style={{ backgroundColor: 'transparent', border: '0px' }} onClick={() => props.handleModal(row.codcli)} >
                            <BsFileText size="22" color={"#003388"} />
                        </button>
                    </TextOnlyTooltip>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0, borderBottom: '1px solid #ccc' }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        {localLoading ?
                            <div style={{ display: 'flex', marginBottom: "2em", alignItems: 'center', justifyContent: 'center' }}>
                                <ReactLoading type={"bars"} color={"#0252a8"} height={25} width={50} />
                            </div>
                            :
                            <Box margin={1}>
                                <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Andamento do Pedido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {localHistorico instanceof Array && localHistorico.length > 0 ?
                                            <></>
                                            :
                                            <TableRow>
                                                <TableCell>Nenhuma informação encontrada.</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </Box>
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

